import { AxiosResponse } from "axios";
import { axiosInstance } from "../axios-instance";
const getBranches = "getBranch";
const getMenu = "getMenu";
const getCategory = "getCategory";
const getProduct = "getProduct";
const getProductById = "getProductById";
const getOption = "getOption";
const getStyle = "getStyle";
const getSocialMedia = "getSocialMedia";
const getProductCommon = "getProductCommon";
const getProductNew = "getProductNew";
const getProductPriceOffer = "getProductPriceOffer";
const menuServices = {
  getBranches: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${getBranches}`, payload),
  getMenu: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${getMenu}`, payload),
  getCategory: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${getCategory}`, payload),
  getProduct: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${getProduct}`, payload),
  getProductById: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(
      `${getProductById}/${payload.productId}&${payload.visit}`,
      { domain: payload.domain }
    ),
  getOption: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${getOption}`, payload),
  getStyle: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${getStyle}`, payload),
  getSocial: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${getSocialMedia}`, payload),
  ////////////////////////////////////////////////////////
  getProductCommon: (branch_id: number): Promise<AxiosResponse> =>
    axiosInstance().get(`${getProductCommon}/${branch_id}`),
  getProductNew: (branch_id: number): Promise<AxiosResponse> =>
    axiosInstance().get(`${getProductNew}/${branch_id}`),
  getProductPriceOffer: (params: any): Promise<AxiosResponse> =>
    axiosInstance().get(
      `${getProductPriceOffer}/${params.branch_id}&${params.domain}`
    ),
  searchProduct: (params: any): Promise<AxiosResponse> =>
    axiosInstance().post(`searchProduct`, params),
};

export default menuServices;
